import { useQuery } from "react-query";
import { supportWidgetApi } from "@circle-react/api/supportWidgetApi";

export const useListPosts = (spaceId: string | number, query: string) =>
  useQuery(
    ["posts", "list", spaceId, query],
    () =>
      supportWidgetApi.listPosts({
        spaceId,
        searchText: query,
      }),
    { retry: false },
  );
